<div class="notes">
  <h5>Staff journal notes ({{ notes.length }})</h5>
  @if (!isEditing) {
    <div>
      <mat-form-field class="placeholder-input" appearance="outline" (click)="onEdit()">
        <input matInput placeholder="Add a journal note" />
      </mat-form-field>
    </div>
  }

  @if (isEditing) {
    <app-staff-journal-note-input
      (create)="onSave($event)"
      [note]="note"
      (cancel)="onCancel()"
      [isNewNote]="true"
      labelText="Add a journal note"
      />
  }

  @for (note of notes; track note) {
    <app-staff-journal-note
      [note]="note"
      (edit)="onEditNote($event)"
      (delete)="onDeleteNote($event)"
    ></app-staff-journal-note>
  }
</div>
